import { memo as _$memo } from "@opentui/solid";
import { spread as _$spread } from "@opentui/solid";
import { mergeProps as _$mergeProps } from "@opentui/solid";
import { createComponent as _$createComponent } from "@opentui/solid";
import { effect as _$effect } from "@opentui/solid";
import { insert as _$insert } from "@opentui/solid";
import { createTextNode as _$createTextNode } from "@opentui/solid";
import { insertNode as _$insertNode } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { createMemo, createSignal, Match, Show, Switch } from "solid-js";
import { useRouteData } from "@tui/context/route";
import { useSync } from "@tui/context/sync";
import { pipe, sumBy } from "remeda";
import { useTheme } from "@tui/context/theme";
import { SplitBorder } from "@tui/component/border";
import { useCommandDialog } from "@tui/component/dialog-command";
import { useKeybind } from "../../context/keybind";
import { Flag } from "@/flag/flag";
import { useTerminalDimensions } from "@opentui/solid";
const Title = props => {
  const {
    theme
  } = useTheme();
  return (() => {
    var _el$ = _$createElement("text"),
      _el$2 = _$createElement("span"),
      _el$4 = _$createTextNode(` `),
      _el$5 = _$createElement("span");
    _$insertNode(_el$, _el$2);
    _$insertNode(_el$, _el$4);
    _$insertNode(_el$, _el$5);
    _$insertNode(_el$2, _$createTextNode(`#`));
    _$setProp(_el$2, "style", {
      bold: true
    });
    _$setProp(_el$5, "style", {
      bold: true
    });
    _$insert(_el$5, () => props.session().title);
    _$effect(_$p => _$setProp(_el$, "fg", theme.text, _$p));
    return _el$;
  })();
};
const ContextInfo = props => {
  const {
    theme
  } = useTheme();
  return _$createComponent(Show, {
    get when() {
      return props.context();
    },
    get children() {
      var _el$6 = _$createElement("text"),
        _el$7 = _$createTextNode(` (`),
        _el$8 = _$createTextNode(`)`);
      _$insertNode(_el$6, _el$7);
      _$insertNode(_el$6, _el$8);
      _$setProp(_el$6, "wrapMode", "none");
      _$setProp(_el$6, "flexShrink", 0);
      _$insert(_el$6, () => props.context(), _el$7);
      _$insert(_el$6, () => props.cost(), _el$8);
      _$effect(_$p => _$setProp(_el$6, "fg", theme.textMuted, _$p));
      return _el$6;
    }
  });
};
const WorkspaceInfo = props => {
  const {
    theme
  } = useTheme();
  return _$createComponent(Show, {
    get when() {
      return props.workspace();
    },
    get children() {
      var _el$9 = _$createElement("text");
      _$setProp(_el$9, "wrapMode", "none");
      _$setProp(_el$9, "flexShrink", 0);
      _$insert(_el$9, () => props.workspace());
      _$effect(_$p => _$setProp(_el$9, "fg", theme.textMuted, _$p));
      return _el$9;
    }
  });
};
export function Header() {
  const route = useRouteData("session");
  const sync = useSync();
  const session = createMemo(() => sync.session.get(route.sessionID));
  const messages = createMemo(() => sync.data.message[route.sessionID] ?? []);
  const cost = createMemo(() => {
    const total = pipe(messages(), sumBy(x => x.role === "assistant" ? x.cost : 0));
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(total);
  });
  const context = createMemo(() => {
    const last = messages().findLast(x => x.role === "assistant" && x.tokens.output > 0);
    if (!last) return;
    const total = last.tokens.input + last.tokens.output + last.tokens.reasoning + last.tokens.cache.read + last.tokens.cache.write;
    const model = sync.data.provider.find(x => x.id === last.providerID)?.models[last.modelID];
    let result = total.toLocaleString();
    if (model?.limit.context) {
      result += "  " + Math.round(total / model.limit.context * 100) + "%";
    }
    return result;
  });
  const workspace = createMemo(() => {
    const id = session()?.workspaceID;
    if (!id) return "Workspace local";
    const info = sync.workspace.get(id);
    if (!info) return `Workspace ${id}`;
    return `Workspace ${id} (${info.type})`;
  });
  const {
    theme
  } = useTheme();
  const keybind = useKeybind();
  const command = useCommandDialog();
  const [hover, setHover] = createSignal(null);
  const dimensions = useTerminalDimensions();
  const narrow = createMemo(() => dimensions().width < 80);
  return (() => {
    var _el$0 = _$createElement("box"),
      _el$1 = _$createElement("box");
    _$insertNode(_el$0, _el$1);
    _$setProp(_el$0, "flexShrink", 0);
    _$setProp(_el$1, "paddingTop", 1);
    _$setProp(_el$1, "paddingBottom", 1);
    _$setProp(_el$1, "paddingLeft", 2);
    _$setProp(_el$1, "paddingRight", 1);
    _$spread(_el$1, _$mergeProps(SplitBorder, {
      "border": ["left"],
      get borderColor() {
        return theme.border;
      },
      "flexShrink": 0,
      get backgroundColor() {
        return theme.backgroundPanel;
      }
    }), true);
    _$insert(_el$1, _$createComponent(Switch, {
      get children() {
        return [_$createComponent(Match, {
          get when() {
            return session()?.parentID;
          },
          get children() {
            var _el$10 = _$createElement("box"),
              _el$11 = _$createElement("box"),
              _el$12 = _$createElement("box"),
              _el$13 = _$createElement("box"),
              _el$14 = _$createElement("text"),
              _el$15 = _$createTextNode(`Parent `),
              _el$16 = _$createElement("span"),
              _el$17 = _$createElement("box"),
              _el$18 = _$createElement("text"),
              _el$19 = _$createTextNode(`Prev `),
              _el$20 = _$createElement("span"),
              _el$21 = _$createElement("box"),
              _el$22 = _$createElement("text"),
              _el$23 = _$createTextNode(`Next `),
              _el$24 = _$createElement("span");
            _$insertNode(_el$10, _el$11);
            _$insertNode(_el$10, _el$12);
            _$setProp(_el$10, "flexDirection", "column");
            _$setProp(_el$10, "gap", 1);
            _$setProp(_el$11, "justifyContent", "space-between");
            _$insert(_el$11, (() => {
              var _c$ = _$memo(() => !!Flag.OPENCODE_EXPERIMENTAL_WORKSPACES_TUI);
              return () => _c$() ? (() => {
                var _el$26 = _$createElement("box"),
                  _el$27 = _$createElement("text"),
                  _el$28 = _$createElement("b");
                _$insertNode(_el$26, _el$27);
                _$setProp(_el$26, "flexDirection", "column");
                _$insertNode(_el$27, _el$28);
                _$insertNode(_el$28, _$createTextNode(`Subagent session`));
                _$insert(_el$26, _$createComponent(WorkspaceInfo, {
                  workspace: workspace
                }), null);
                _$effect(_$p => _$setProp(_el$27, "fg", theme.text, _$p));
                return _el$26;
              })() : (() => {
                var _el$30 = _$createElement("text"),
                  _el$31 = _$createElement("b");
                _$insertNode(_el$30, _el$31);
                _$insertNode(_el$31, _$createTextNode(`Subagent session`));
                _$effect(_$p => _$setProp(_el$30, "fg", theme.text, _$p));
                return _el$30;
              })();
            })(), null);
            _$insert(_el$11, _$createComponent(ContextInfo, {
              context: context,
              cost: cost
            }), null);
            _$insertNode(_el$12, _el$13);
            _$insertNode(_el$12, _el$17);
            _$insertNode(_el$12, _el$21);
            _$setProp(_el$12, "flexDirection", "row");
            _$setProp(_el$12, "gap", 2);
            _$insertNode(_el$13, _el$14);
            _$setProp(_el$13, "onMouseOver", () => setHover("parent"));
            _$setProp(_el$13, "onMouseOut", () => setHover(null));
            _$setProp(_el$13, "onMouseUp", () => command.trigger("session.parent"));
            _$insertNode(_el$14, _el$15);
            _$insertNode(_el$14, _el$16);
            _$insert(_el$16, () => keybind.print("session_parent"));
            _$insertNode(_el$17, _el$18);
            _$setProp(_el$17, "onMouseOver", () => setHover("prev"));
            _$setProp(_el$17, "onMouseOut", () => setHover(null));
            _$setProp(_el$17, "onMouseUp", () => command.trigger("session.child.previous"));
            _$insertNode(_el$18, _el$19);
            _$insertNode(_el$18, _el$20);
            _$insert(_el$20, () => keybind.print("session_child_cycle_reverse"));
            _$insertNode(_el$21, _el$22);
            _$setProp(_el$21, "onMouseOver", () => setHover("next"));
            _$setProp(_el$21, "onMouseOut", () => setHover(null));
            _$setProp(_el$21, "onMouseUp", () => command.trigger("session.child.next"));
            _$insertNode(_el$22, _el$23);
            _$insertNode(_el$22, _el$24);
            _$insert(_el$24, () => keybind.print("session_child_cycle"));
            _$effect(_p$ => {
              var _v$ = narrow() ? "column" : "row",
                _v$2 = narrow() ? 1 : 0,
                _v$3 = hover() === "parent" ? theme.backgroundElement : theme.backgroundPanel,
                _v$4 = theme.text,
                _v$5 = {
                  fg: theme.textMuted
                },
                _v$6 = hover() === "prev" ? theme.backgroundElement : theme.backgroundPanel,
                _v$7 = theme.text,
                _v$8 = {
                  fg: theme.textMuted
                },
                _v$9 = hover() === "next" ? theme.backgroundElement : theme.backgroundPanel,
                _v$0 = theme.text,
                _v$1 = {
                  fg: theme.textMuted
                };
              _v$ !== _p$.e && (_p$.e = _$setProp(_el$11, "flexDirection", _v$, _p$.e));
              _v$2 !== _p$.t && (_p$.t = _$setProp(_el$11, "gap", _v$2, _p$.t));
              _v$3 !== _p$.a && (_p$.a = _$setProp(_el$13, "backgroundColor", _v$3, _p$.a));
              _v$4 !== _p$.o && (_p$.o = _$setProp(_el$14, "fg", _v$4, _p$.o));
              _v$5 !== _p$.i && (_p$.i = _$setProp(_el$16, "style", _v$5, _p$.i));
              _v$6 !== _p$.n && (_p$.n = _$setProp(_el$17, "backgroundColor", _v$6, _p$.n));
              _v$7 !== _p$.s && (_p$.s = _$setProp(_el$18, "fg", _v$7, _p$.s));
              _v$8 !== _p$.h && (_p$.h = _$setProp(_el$20, "style", _v$8, _p$.h));
              _v$9 !== _p$.r && (_p$.r = _$setProp(_el$21, "backgroundColor", _v$9, _p$.r));
              _v$0 !== _p$.d && (_p$.d = _$setProp(_el$22, "fg", _v$0, _p$.d));
              _v$1 !== _p$.l && (_p$.l = _$setProp(_el$24, "style", _v$1, _p$.l));
              return _p$;
            }, {
              e: undefined,
              t: undefined,
              a: undefined,
              o: undefined,
              i: undefined,
              n: undefined,
              s: undefined,
              h: undefined,
              r: undefined,
              d: undefined,
              l: undefined
            });
            return _el$10;
          }
        }), _$createComponent(Match, {
          when: true,
          get children() {
            var _el$25 = _$createElement("box");
            _$setProp(_el$25, "justifyContent", "space-between");
            _$setProp(_el$25, "gap", 1);
            _$insert(_el$25, (() => {
              var _c$2 = _$memo(() => !!Flag.OPENCODE_EXPERIMENTAL_WORKSPACES_TUI);
              return () => _c$2() ? (() => {
                var _el$33 = _$createElement("box");
                _$setProp(_el$33, "flexDirection", "column");
                _$insert(_el$33, _$createComponent(Title, {
                  session: session
                }), null);
                _$insert(_el$33, _$createComponent(WorkspaceInfo, {
                  workspace: workspace
                }), null);
                return _el$33;
              })() : _$createComponent(Title, {
                session: session
              });
            })(), null);
            _$insert(_el$25, _$createComponent(ContextInfo, {
              context: context,
              cost: cost
            }), null);
            _$effect(_$p => _$setProp(_el$25, "flexDirection", narrow() ? "column" : "row", _$p));
            return _el$25;
          }
        })];
      }
    }));
    return _el$0;
  })();
}